import C from 'utils/values/constant.util';

const SMS_BUNDLE = C({
  oneHundred: 'one_hundred',
  fiveHundreds: 'five_hundreds',
  twoThousands: 'two_thousands',
});

// noinspection JSUnusedGlobalSymbols
export default SMS_BUNDLE;
